import React from 'react';
import SiteNav from './components/SiteNav';
import './App.css';

function MansfieldianAppPage() {
  return (
    <div
      className="App index-page"
      style={{
        backgroundImage: `url('/background/background.png')`,
        backgroundColor: '#f0f0f0'
      }}
    >
      <SiteNav />
      <header className="App-header index-header">
        <div className="index-panel info-panel">
          <h2 className="index-title">Mansfieldian App</h2>
          <p className="index-subtitle">Coming soon</p>
        </div>
      </header>
    </div>
  );
}

export default MansfieldianAppPage;
